 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALF_TITLE from '@/components/half_title'
 import TITLE_PAGE from '@/components/title_page'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import CONTENTS from '@/components/contents'
 import LIST_OF_ILLUSTRATIONS from '@/components/list_of_illustrations'
 import LIST_OF_PRINCIPAL_CHARACTERS from '@/components/list_of_principal_characters'
 import PREFACE from '@/components/preface'
 import CHAPTER_1 from '@/components/chapter_1'
 import CHAPTER_2 from '@/components/chapter_2'
 import CHAPTER_3 from '@/components/chapter_3'
 import CHAPTER_4 from '@/components/chapter_4'
 import CHAPTER_5 from '@/components/chapter_5'
 import CHAPTER_6 from '@/components/chapter_6'
 import CHAPTER_7 from '@/components/chapter_7'
 import CHAPTER_8 from '@/components/chapter_8'
 import CHAPTER_9 from '@/components/chapter_9'
 import CHAPTER_10 from '@/components/chapter_10'
 import CHAPTER_11 from '@/components/chapter_11'
 import CHAPTER_12 from '@/components/chapter_12'
 import CONCLUSION from '@/components/conclusion'
 import EPILOGUE_UBI_SUNT from '@/components/epilogue_ubi_sunt'
 import NOTES from '@/components/notes'
 import A_BIBLIOGRAPHICAL_ESSAY from '@/components/a_bibliographical_essay'
 import BIBLIOGRAPHY from '@/components/bibliography'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/list_of_illustrations",
 			"name" : "list_of_illustrations",
 			"component" : LIST_OF_ILLUSTRATIONS
 		},
 		{
 			"path" : "/list_of_principal_characters",
 			"name" : "list_of_principal_characters",
 			"component" : LIST_OF_PRINCIPAL_CHARACTERS
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/chapter_1",
 			"name" : "chapter_1",
 			"component" : CHAPTER_1
 		},
 		{
 			"path" : "/chapter_2",
 			"name" : "chapter_2",
 			"component" : CHAPTER_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js